import { observer } from 'mobx-react-lite';
import CornersPanel from './CornersPanel';
import type { CornersPanelProps, CornersPanelValueProps } from './types';

export type { CornersPanelProps, CornersPanelValueProps };
export default observer(CornersPanel); // MANUAL OVERRIDE
